import React from 'react';

import './manutencao.css';

const MaintenanceIllustration = () => (
    <svg
        className="maintenance-illustration"
        viewBox="0 0 440 210"
        role="img"
        aria-label="Ferramentas de manutenção"
    >
        <path d="M55 166c-25 0-45-19-45-43 0-22 17-40 39-43 7-31 35-53 68-53 13 0 25 3 36 10C169 14 196 0 226 0c39 0 73 24 87 59 8-4 18-6 28-6 30 0 55 21 61 49 16 6 28 21 28 39 0 9-3 18-8 25H55z" fill="#edf7ef" />
        <path d="M331 27l8-20m13 26 17-14m-8 29 23-1" fill="none" stroke="#edf7ef" strokeLinecap="round" strokeWidth="7" />

        <rect x="105" y="18" width="225" height="158" rx="12" fill="#f9fbfb" stroke="#d8e0e2" strokeWidth="2" />
        <path d="M117 18h201a12 12 0 0 1 12 12v22H105V30a12 12 0 0 1 12-12z" fill="#9ca7ab" />
        <circle cx="126" cy="35" r="6" fill="#f6f8f8" />
        <circle cx="145" cy="35" r="6" fill="#f6f8f8" />
        <circle cx="164" cy="35" r="6" fill="#f6f8f8" />

        <g transform="rotate(-43 214 113)">
            <path d="M185 66c12 8 28 7 39-3l-17 29 35 60c4 7 2 16-5 20s-16 2-20-5l-35-60-34 1c15-8 23-25 19-41l16 15 17-10-15-6z" fill="#677279" />
            <circle cx="229" cy="159" r="6" fill="#e8edef" />
        </g>
        <g transform="rotate(42 218 112)">
            <path d="M210 60h17l5 55h-27z" fill="#f6a91b" />
            <path d="M204 108h29v62a14 14 0 0 1-29 0z" fill="#ffb51d" />
            <path d="M211 119h5v45h-5z" fill="#e99a12" />
            <path d="M221 119h5v45h-5z" fill="#ffd35e" />
        </g>

        <g transform="translate(305 83)">
            <path d="M33 0h20l5 24H28z" fill="#ff7a2c" />
            <path d="M22 24h42l7 30H15z" fill="#ff7a2c" />
            <path d="M10 54h66l10 38H0z" fill="#ff7a2c" />
            <path d="M25 34h36l3 13H22zM14 65h58l4 16H10z" fill="#fff" />
            <rect x="-7" y="88" width="100" height="12" rx="6" fill="#f36b22" />
        </g>
    </svg>
);

const Manutencao = () => (
    <main className="maintenance-page">
        <section className="maintenance-card" aria-labelledby="maintenance-title">
            <MaintenanceIllustration />

            <h1 id="maintenance-title">Sistema em Manutenção</h1>
            <p className="maintenance-description">
                O Portal de Transparência de Manutenção e Requalificação das Escolas Estaduais<br className="maintenance-desktop-break" />
                {' '}e Unidades Administrativas Estaduais está temporariamente indisponível<br className="maintenance-desktop-break" />
                {' '}para manutenção e melhorias.
            </p>

            <div className="maintenance-notice" role="status">
                <span className="maintenance-info" aria-hidden="true">i</span>
                <div>
                    <strong>Em breve voltaremos com um serviço ainda melhor!</strong>
                    <span>Agradecemos a compreensão de todos.</span>
                </div>
            </div>

            <div className="maintenance-signature">
                <img
                    src={process.env.PUBLIC_URL + '/seduc_logo_manutencao.png'}
                    alt="Seduc - Secretaria da Educação do Governo do Estado do Ceará"
                />
                <span aria-hidden="true" />
                <strong>Educação que<br />transforma vidas</strong>
            </div>
        </section>
    </main>
);

export default Manutencao;
